import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.DOM.notification = document.querySelector(this.DOM.view.dataset.block);
    //
    this.tl = gsap.timeline();

    this.tl
      .fromTo(
        this.DOM.notification,
        { y: '-100%' },
        { y: 0, ease: 'cubic.out', duration: 0.5, delay: 1 }
      )
      .to(
        this.DOM.notification,
        { y: '-100%', ease: 'cubic.out', duration: 0.5 },
        '>+4'
      );
  }
}
